"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectableListWithSearch = void 0;
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var styled_components_1 = __importDefault(require("styled-components"));
var Skeleton_1 = require("../Skeleton");
var CssScroller_1 = require("../CssScroller");
var Typography_1 = require("../Typography");
var createOnPopupScroll_1 = require("../../utils/createOnPopupScroll");
var array_1 = require("../../utils/array");
var transifex_1 = require("../../transifex");
var LIST_PADDING = 8;
var StyledOptionSpace = styled_components_1.default(antd_1.Space)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  &:hover {\n    background: whitesmoke !important;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  ",
    "\n\n  &:hover {\n    background: whitesmoke !important;\n  }\n\n  ",
    "\n\n  ",
    "\n\n  ",
    "\n"])), function (_a) {
    var $background = _a.$background;
    return "\n    background: " + $background + ";\n  ";
}, function (_a) {
    var $disabled = _a.$disabled, $background = _a.$background;
    return $disabled
        ? "\n      &:hover {\n        background: " + $background + " !important;\n      }\n  "
        : "";
}, function (_a) {
    var $selected = _a.$selected, $background = _a.$background;
    return $selected
        ? "\n      background: " + $background + " !important;\n      &:hover {\n        background: " + $background + " !important;\n      }\n  "
        : "";
}, function (_a) {
    var $noHover = _a.$noHover;
    return $noHover
        ? "\n        &:hover {\n          background: transparent !important;\n        }\n  "
        : "";
});
var variantConfig = {
    radio: {
        optionStyles: {
            paddingTop: 12,
            paddingBottom: 12,
            paddingRight: 16,
        },
        rowGap: 0,
        backgroundColor: "whitesmoke",
        optionBackground: "#E6EFF8",
        radioEnabled: true,
        multipleEnabled: false,
        optionDisabledColor: "#f1f1f1",
        paddingHorizontal: LIST_PADDING,
    },
    default: {
        optionStyles: {
            paddingTop: LIST_PADDING,
            paddingBottom: LIST_PADDING,
            paddingRight: LIST_PADDING,
        },
        rowGap: 4,
        backgroundColor: "white",
        optionBackground: "#E6F7FF",
        radioEnabled: false,
        multipleEnabled: true,
        optionDisabledColor: "rgba(0, 0, 0, 0.03)",
        paddingHorizontal: 0,
    },
    "no-selection": {
        optionStyles: {
            paddingTop: LIST_PADDING,
            paddingBottom: LIST_PADDING,
            paddingRight: LIST_PADDING,
            cursor: "default",
        },
        rowGap: 4,
        backgroundColor: "white",
        optionBackground: "#E6F7FF",
        radioEnabled: false,
        multipleEnabled: true,
        optionDisabledColor: "rgba(0, 0, 0, 0.03)",
        paddingHorizontal: 0,
    },
};
var Context = react_1.createContext({
    variant: "default",
    mode: "simple",
    value: [],
});
var useOptContext = function () { return react_1.useContext(Context); };
var OptionGroup = function (_a) {
    var title = _a.title, children = _a.children;
    return (react_1.default.createElement(antd_1.Space, { direction: "vertical", style: {
            width: "100%",
            justifyContent: "space-between",
            padding: "8px 0px",
            cursor: "pointer",
        } },
        react_1.default.createElement(Typography_1.Typography, { type: "secondary", style: { paddingLeft: 16 } }, title),
        children));
};
var Option = function (_a) {
    var label = _a.label, value = _a.value, inGroup = _a.inGroup, disabled = _a.disabled, extra = _a.extra;
    var _b = useOptContext(), currentValue = _b.value, mode = _b.mode, onChange = _b.onChange, variant = _b.variant, toggle = _b.toggle, listDisabled = _b.disabled;
    var selected = currentValue === null || currentValue === void 0 ? void 0 : currentValue.includes(value);
    var variantProperties = variantConfig[variant !== null && variant !== void 0 ? variant : "default"];
    var optionDisabled = disabled || listDisabled;
    return (react_1.default.createElement(StyledOptionSpace, { "$selected": selected, "$disabled": optionDisabled, "$background": array_1.array(variant === "no-selection" && "transparent", optionDisabled && variantProperties.optionDisabledColor, selected && variantProperties.optionBackground, "transparent")[0], "$noHover": variant === "no-selection", style: __assign({ width: "100%", justifyContent: "space-between", cursor: optionDisabled ? "not-allowed" : "pointer", paddingLeft: inGroup ? 24 : 16 }, variantProperties.optionStyles), onClick: function () {
            if (optionDisabled || variant === "no-selection")
                return;
            if (selected) {
                if (toggle)
                    onChange === null || onChange === void 0 ? void 0 : onChange(currentValue === null || currentValue === void 0 ? void 0 : currentValue.filter(function (val) { return val !== value; }));
            }
            else {
                if (mode === "simple" || !variantProperties.multipleEnabled) {
                    onChange === null || onChange === void 0 ? void 0 : onChange([value]);
                }
                if (mode === "multiple" && variantProperties.multipleEnabled) {
                    onChange === null || onChange === void 0 ? void 0 : onChange(__spreadArray(__spreadArray([], currentValue), [value]));
                }
            }
        } },
        react_1.default.createElement("div", null,
            variantProperties.radioEnabled && react_1.default.createElement(antd_1.Radio, { checked: selected }),
            label),
        react_1.default.createElement(antd_1.Space, { size: 4 },
            mode === "multiple" &&
                selected &&
                variantProperties.multipleEnabled && (react_1.default.createElement(antd_1.Button, { type: "link", ghost: true, icon: react_1.default.createElement(icons_1.CheckOutlined, null) })),
            extra)));
};
var defaultToggleState = {
    simple: false,
    multiple: true,
};
var SelectableListWithSearch = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? "default" : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, value = _a.value, _d = _a.loading, loading = _d === void 0 ? false : _d, _e = _a.loadingMore, loadingMore = _e === void 0 ? false : _e, _f = _a.showSearch, showSearch = _f === void 0 ? false : _f, onSearch = _a.onSearch, searchValue = _a.searchValue, _g = _a.mode, mode = _g === void 0 ? "simple" : _g, children = _a.children, onChange = _a.onChange, notFound = _a.notFound, onMore = _a.onMore, style = _a.style, overwriteToggle = _a.toggle, _h = _a.loaderNode, loaderNode = _h === void 0 ? (react_1.default.createElement(Skeleton_1.StyledSkeletonInput, { size: "small", className: "ant-skeleton-width-full" })) : _h, addonTop = _a.addonTop;
    var txSearch = transifex_1.useTxStrings().txSearch;
    var variantProperties = variantConfig[variant !== null && variant !== void 0 ? variant : "default"];
    var onScroll = react_1.useCallback(function () {
        createOnPopupScroll_1.createOnPopupScroll(onMore);
    }, [onMore]);
    return (react_1.default.createElement(Context.Provider, { value: {
            mode: mode,
            value: value,
            onChange: onChange,
            variant: variant,
            disabled: disabled,
            toggle: overwriteToggle !== undefined
                ? overwriteToggle
                : defaultToggleState[mode],
        } },
        react_1.default.createElement("div", { className: "wh-vertical-scroller-container", style: __assign({ rowGap: showSearch ? LIST_PADDING : 0, backgroundColor: variantProperties.backgroundColor, paddingTop: LIST_PADDING, paddingBottom: LIST_PADDING }, style) },
            react_1.default.createElement("div", { style: {
                    // padding: `0px ${variantProperties.paddingHorizontal}px`,
                    paddingLeft: variantProperties.paddingHorizontal,
                    paddingRight: variantProperties.paddingHorizontal,
                } },
                react_1.default.createElement(antd_1.Row, { gutter: [0, 16] },
                    addonTop && react_1.default.createElement(antd_1.Col, { xs: 24 }, addonTop),
                    showSearch && (react_1.default.createElement(antd_1.Col, { xs: 24 },
                        react_1.default.createElement(antd_1.Input, __assign({}, (searchValue ? { value: searchValue } : {}), { onChange: function (e) {
                                onSearch === null || onSearch === void 0 ? void 0 : onSearch(e.target.value);
                            }, disabled: disabled, prefix: react_1.default.createElement(icons_1.SearchOutlined, null), placeholder: txSearch() })))))),
            react_1.default.createElement("div", { className: "wh-vertical-scroller-container-scroll" },
                react_1.default.createElement(CssScroller_1.CssScrollerDiv, { style: {
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                    }, defaultYScroller: true, onScroll: onScroll },
                    notFound && react_1.default.createElement(antd_1.Empty, { description: transifex_1.TX_NO_DATA }),
                    !loading && (react_1.default.createElement("div", { style: {
                            display: "flex",
                            flexDirection: "column",
                            rowGap: variantProperties.rowGap,
                        } }, children)),
                    (loading || loadingMore) && (react_1.default.createElement(antd_1.Space, { direction: "vertical", style: {
                            paddingTop: loading ? 0 : LIST_PADDING,
                            paddingLeft: variantProperties.paddingHorizontal,
                            paddingRight: variantProperties.paddingHorizontal,
                            width: "100%",
                        } }, Array.from({ length: loadingMore ? 2 : 10 }).map(function () { return loaderNode; }))))))));
};
exports.SelectableListWithSearch = SelectableListWithSearch;
SelectableListWithSearch.Option = Option;
SelectableListWithSearch.OptionGroup = OptionGroup;
var templateObject_1;
